import Tile from '@atoms/Tile/Tile';
import Link from '@atoms/Link/Link';
import { StyledActiveFilters, StyledTileContainer } from './SelectedFilters.styles';
import { usePathname, useSearchParams } from 'next/navigation';
import type { BreadcrumbDataSearchStateData } from '@occ/api-client';

interface Props {
  breadcrumbs: Array<BreadcrumbDataSearchStateData>;
}

export interface BreadcrumbDataWithFaceValueName extends BreadcrumbDataSearchStateData {
  facetValueName: string;
}

const SelectedFilters = ({ breadcrumbs }: Props) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentQuery = searchParams ? Object.fromEntries(searchParams.entries()) : {};

  return (
    <StyledActiveFilters>
      <StyledTileContainer>
        {breadcrumbs
          .filter(
            (breadcrumb): breadcrumb is BreadcrumbDataWithFaceValueName => breadcrumb.facetValueName !== undefined
          )
          .map((breadcrumb) => {
            let filterQuery = breadcrumb?.removeQuery?.query?.value;
            if (pathname?.startsWith('/erbjudanden') && breadcrumb?.removeQuery?.url) {
              filterQuery = decodeURIComponent(breadcrumb.removeQuery.url);
            }

            const newQuery = { ...currentQuery, q: filterQuery };
            const queryString = new URLSearchParams(newQuery as any).toString();
            const newPath = queryString ? `${pathname}?${queryString}` : pathname || '';

            return (
              <Link scroll={false} href={newPath} key={breadcrumb.facetValueCode}>
                <Tile selected={false} name={breadcrumb.facetValueName} />
              </Link>
            );
          })}
      </StyledTileContainer>
    </StyledActiveFilters>
  );
};

export default SelectedFilters;
